import React from 'react';
import {useIsDesktop} from '../../../../shared/hooks/useIsDesktop';
import ViewDesktop from './viewDesktop';
import ViewMobile from './viewMobile';
import {Props} from './model';

export const Footer = ({prevNews, nextNews}: Props) => {
  const isDesktop = useIsDesktop();
  const View = isDesktop ? ViewDesktop : ViewMobile;
  return <View prevNews={prevNews} nextNews={nextNews} />;
};
